module.exports = __webpack_public_path__ + "img/video-files.1279d96e.svg";